<template>
	<div id="historical-audit-log">
		<div v-if="auditLog !== undefined">
			<h3 class="line-header">Audit Log</h3>
			<div v-for="(item, index) in auditLog.slice(0,5)" :key="index" class="audit-log-display">
				<div class="audit-item">{{ item.timestamp.replace("T", " ").substr(0, 19) }}</div>
				<div v-if="item.messages !== undefined">
					<div v-for="(message, index) in item.messages.slice(0,5)" :key="index" class="audit-log-display">
						<div class="audit-item">{{ message }}</div>
					</div>
				</div>
				<div v-else>
					<div class="audit-item">Message not found</div>
				</div>
			</div>
		</div>
		<v-skeleton-loader v-else type="table"></v-skeleton-loader>
	</div>
</template>

<script>
	/**
	 * @fileoverview historical-audit-log.vue displays an audit log on the tenant and profile levels.
	 * It relies on vuex to map the state variables from the store files.
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import { mapState } from 'vuex';

	export default {
		data() {
			return {
			}
		},
		props: {
			/**
			 * Boolean value for displaying the profile audit log
			 */
			profileLevel: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapState({
				historicalAuditLog: (state) => state.config.historicalAuditLog,
				profileAuditLog: (state) => state.config.profileAuditLog,
			}),
			/**
			 * Return the audit log specific to the profile level
			 * @returns either profile or historical audit log 
			 */
			auditLog() {
				if (this.profileLevel) {
					return this.profileAuditLog;
				}
				return this.historicalAuditLog;
			}
		}
	}
</script>

<style lang="scss">
	@import "@/design/components/_historical-audit-log.scss";
</style>